import { Button, Tooltip } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

export const SearchButton = ({ children = 'Buscar', compact = false, ...buttonProps }) => {
  return (
    <Tooltip title={compact ? children : null}>
      <Button
        type='primary'
        icon={<SearchOutlined />}
        {...buttonProps}
      >
        {compact ? undefined : children}
      </Button>
    </Tooltip>
  )
};

// Marca el componente como un botón de Ant Design para que sea tratado como tal por los componentes que lo requieren
SearchButton.__ANT_BUTTON = true;